module.exports = __webpack_public_path__ + "static/media/PC-banner1.3357cd18.png";